
import { onClickOutside, useElementBounding } from '@vueuse/core'
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
  watch,
  watchEffect,
} from 'vue'
import { Conversation } from '../../interface'

const ListItem: any = defineComponent({
  props: {
    conversation: {
      type: Object,
      default: () => ({}),
    },
    handleConversation: {
      type: Object,
      default: () => ({}),
    },
    currentID: {
      type: String,
      default: () => '',
    },
    toggleID: {
      type: String,
      default: () => '',
    },
    isH5: {
      type: Boolean,
      default: () => false,
    },
    displayOnlineStatus: {
      type: Boolean,
      default: () => false,
    },
    userStatusList: {
      type: Map,
      default: () => new Map(),
    },
    types: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: any, ctx: any) {
    const data = reactive({
      conversation: {} as Conversation,
      currentID: '',
      currentConversation: {},
      toggle: false,
      currentuserID: '',
      conversationType: '',
      loop: 0,
      displayOnlineStatus: false,
      userStatusList: new Map(),
      contactInfoFlag: true,
    })
    const dialog: any = ref()
    const content: any = ref()

    onClickOutside(content, () => {
      if (data.toggle === true) {
        ctx.emit('toggle', '')
      }
    })

    watchEffect(() => {
      data.conversation = props.conversation
      data.currentID = props.currentID
      data.toggle = false
      data.displayOnlineStatus = props.displayOnlineStatus
      data.userStatusList = props.userStatusList
      props.toggleID === props.conversation.conversationID &&
        (data.toggle = true)
    })

    watch(
      () => data.toggle,
      (val: boolean) => {
        if (val) {
          nextTick(() => {
            const DialogBound = useElementBounding(dialog)
            const ParentEle = content?.value?.offsetParent
            const ParentBound = useElementBounding(ParentEle)
            if (
              DialogBound.top.value -
                ParentBound.top.value -
                DialogBound.height.value -
                30 >
              0
            ) {
              dialog.value.style.top = 'auto'
              dialog.value.style.bottom = '30px'
            }
          })
        }
      }
    )

    const handleListItem = (item: any) => {
      ctx.emit('open', item)
      ctx.emit('toggle', '')
    }

    const toggleDialog = (e?: any) => {
      if (e?.target?.oncontextmenu) {
        e.target.oncontextmenu = function () {
          return false
        }
      }
      ctx.emit('toggle', (data.conversation as any).conversationID)
    }

    const handleItem = (name: string) => {
      ctx.emit('handle', {
        name,
        conversation: data.conversation,
      })
      ctx.emit('toggle', '')
    }

    const showUserOnlineStatus = () => {
      if (
        data.displayOnlineStatus &&
        data.conversation?.type === props.types.CONV_C2C
      )
        return true
      return false
    }

    const hasBaidu = function () {
      const url = window.location.href
      let allParams = url.split('?')[1]
      let params = new URLSearchParams(allParams)
      let tracksource = params.get('tracksource')
      // console.log(tracksource?.toLowerCase(), 'tracksource.lower()1')
      if (tracksource?.toLowerCase() == 'baidu') {
        console.log('包含子字符串')
        return (data.contactInfoFlag = false)
      }
    }
    onMounted(() => {
      hasBaidu()
    })
    return {
      ...toRefs(data),
      handleListItem,
      handleItem,
      dialog,
      content,
      toggleDialog,
      showUserOnlineStatus,
      hasBaidu,
    }
  },
})
export default ListItem
